import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../App';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Call the session endpoint - it will set cookies AND return the token
        const response = await axios.get(`${API}/auth/session?session_id=${sessionId}`, {
          withCredentials: true
        });
        
        const userData = response.data;
        
        // Store the access token in localStorage as fallback for cross-origin cookie issues
        if (userData.access_token) {
          localStorage.setItem('access_token', userData.access_token);
        }
        
        // Set user in context
        setUser({
          user_id: userData.user_id,
          email: userData.email,
          name: userData.name,
          picture: userData.picture,
          auth_provider: 'google'
        });
        
        toast.success(`Bienvenue, ${userData.name}!`);
        
        // Clear the hash and navigate to the original destination if any
        window.history.replaceState(null, '', window.location.pathname);
        let destination = '/dashboard';
        try {
          const stored = sessionStorage.getItem('post_login_redirect');
          if (stored) {
            sessionStorage.removeItem('post_login_redirect');
            destination = stored;
          }
        } catch (_) {}
        navigate(destination, { replace: true });
      } catch (error) {
        console.error('OAuth callback error:', error);
        toast.error('Erreur de connexion Google');
        navigate('/login', { replace: true });
      }
    };

    processOAuthCallback();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mx-auto mb-4"></div>
        <p className="text-charcoal font-body">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
